import { createShallowStore, createStoreWithPersistAndSubscribe } from '@frontend/store';

export interface WorkspaceStore {
  /** ID of the workspace explicitly committed via Apply. Drives workspace mode. */
  selectedWorkspaceId: string | null;
  /** ID of the workspace highlighted in the picker but not yet committed. */
  pendingWorkspaceId: string | null;

  setSelectedWorkspaceId: (workspaceId: string | null) => void;
  setPendingWorkspaceId: (workspaceId: string | null) => void;
  /** Promotes pendingWorkspaceId → selectedWorkspaceId. Called when Apply is clicked. */
  commitPendingWorkspace: () => void;
}

export const useWorkspaceStore = createStoreWithPersistAndSubscribe<WorkspaceStore>(
  (set, get) => ({
    selectedWorkspaceId: null,
    pendingWorkspaceId: null,

    setSelectedWorkspaceId: (workspaceId: string | null) => {
      if (get().selectedWorkspaceId === workspaceId) return;
      set({ selectedWorkspaceId: workspaceId }, false, 'SET_SELECTED_WORKSPACE_ID');
    },

    setPendingWorkspaceId: (workspaceId: string | null) => {
      if (get().pendingWorkspaceId === workspaceId) return;
      set({ pendingWorkspaceId: workspaceId }, false, 'SET_PENDING_WORKSPACE_ID');
    },

    commitPendingWorkspace: () => {
      const { selectedWorkspaceId, pendingWorkspaceId } = get();

      if (selectedWorkspaceId === null && pendingWorkspaceId === null) return;
      set(
        (state) => ({ selectedWorkspaceId: state.pendingWorkspaceId, pendingWorkspaceId: null }),
        false,
        'COMMIT_PENDING_WORKSPACE'
      );
    },
  }),
  {
    name: 'workspace-store',
    version: 1,
    partialize: (state) => ({ selectedWorkspaceId: state.selectedWorkspaceId } as WorkspaceStore),
  },
  {
    name: 'WorkspaceStore',
    enabled: true,
  }
);

export const useWorkspaceShallowStore = createShallowStore(useWorkspaceStore);
